import React from 'react';
export function Footer() {
  return <footer className="w-full px-4 py-12 bg-bg-card border-t border-border-card" data-id="element-137">
      <div className="max-w-6xl mx-auto text-center" data-id="element-138">
        <div className="mb-6" data-id="element-139">
          <h3 className="text-2xl font-black mb-2" data-id="element-140">🏐 VOLEY 360™</h3>
          <p className="text-text-secondary" data-id="element-141">
            El sistema completo para entrenadores de vóley argentinos.
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-6 mb-6 text-sm text-text-secondary" data-id="element-142">
          <a href="mailto:contacto@voley360.com" className="hover:text-orange transition-colors" data-id="element-143">
            📧 contacto@voley360.com
          </a>
          <a href="https://instagram.com/voley360.ar" target="_blank" rel="noopener noreferrer" className="hover:text-orange transition-colors" data-id="element-144">
            📲 @voley360.ar
          </a>
          <a href="https://www.voley360.ar" target="_blank" rel="noopener noreferrer" className="hover:text-orange transition-colors" data-id="element-145">
            🌐 www.voley360.ar
          </a>
        </div>

        <div className="text-sm text-text-secondary" data-id="element-146">
          <p className="mb-2" data-id="element-147">
            © VOLEY 360™ 2025 — Todos los derechos reservados.
          </p>
          <p data-id="element-148">
            Prohibida la reproducción y redistribución sin autorización expresa.
          </p>
        </div>
      </div>
    </footer>;
}